import AppInfo from './app_info'
export default AppInfo